import { t } from '../../utils/i18n';
import searchImage from '../../assets/landing/search-profiles.jpg';
import meetingImage from '../../assets/landing/meeting-parent-nanny.jpg';
import activityImage from '../../assets/landing/child-activity.jpg';

const STEPS = [
  { step: '1', key: 'step1', image: searchImage },
  { step: '2', key: 'step2', image: meetingImage },
  { step: '3', key: 'step3', image: activityImage },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="landing-section">
      <div className="landing-container">
        <header className="landing-section-header landing-section-header--center">
          <h2 className="landing-section-title">{t('landing.howItWorks.title')}</h2>
          <p className="landing-section-subtitle">{t('landing.howItWorks.subtitle')}</p>
        </header>

        <div className="landing-how-grid">
          {STEPS.map(({ step, key, image }) => (
            <article key={key} className="landing-how-card">
              <div className="landing-how-media">
                <img
                  src={image}
                  alt={t(`landing.howItWorks.${key}.imageAlt`)}
                  loading="lazy"
                  width="600"
                  height="450"
                />
                <span className="landing-how-step" aria-hidden="true">{step}</span>
              </div>
              <div className="landing-how-body">
                <h3 className="landing-how-title">{t(`landing.howItWorks.${key}.title`)}</h3>
                <p className="landing-how-desc">{t(`landing.howItWorks.${key}.desc`)}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
